import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { ApiStatus } from "../../utils/api.types";
import { CashInflowPaymentsSliceState } from "../../utils/cashinflow.types";
import { 
    // addCashInflowPayment, 
    attachInvoiceToVendorPayment, 
    fetchCashOutflowPaymentsDetails,
    deletePaymentReceiptOutflow,
    addCashOutflowPayment,
    deleteVendorPayment,
    createVendorPaymentPdf } from "./cashOutflowThunk";

/**
 * CashInflow slice initial state.
 */
const initialState: CashInflowPaymentsSliceState = {
    status: ApiStatus.IDLE,
    errorMessage: ''
}

/**
 * Invoice Slice.
 */
const cashInflowSlice = createSlice({
    name: 'cashInflow',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch payment receipt application
            .addCase(fetchCashOutflowPaymentsDetails.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchCashOutflowPaymentsDetails.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.payments = action?.payload.payments || [];
                state.errorMessage = '';
            })
            .addCase(fetchCashOutflowPaymentsDetails.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // // Add payment
            // .addCase(addCashInflowPayment.pending, (state, action) => {
            //     state.status = ApiStatus.LOADING;
            // })
            // .addCase(addCashInflowPayment.fulfilled, (state, action: any) => {
            //     state.status = ApiStatus.SUCCESS;
            //     state.errorMessage = '';
            // })
            // .addCase(addCashInflowPayment.rejected, (state, action) => {
            //     state.status = ApiStatus.FAILED;
            //     state.errorMessage = action.error.message
            // })

            // Attach vendor invoice to payment
            .addCase(attachInvoiceToVendorPayment.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(attachInvoiceToVendorPayment.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                toast.success('Vendor payment added successfully');
                state.errorMessage = '';
            })
            .addCase(attachInvoiceToVendorPayment.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Add outflow payment
            .addCase(addCashOutflowPayment.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(addCashOutflowPayment.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                toast.success('Vendor payment added successfully');
                state.errorMessage = '';
            })
            .addCase(addCashOutflowPayment.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error(action.error.message || 'Failed to add vendor payment');
            })

            // Delete payment receipt (Outflow)
            .addCase(deletePaymentReceiptOutflow.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(deletePaymentReceiptOutflow.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                const { message } = action.payload;
                toast.success(message || 'Payment deleted successfully');
                state.errorMessage = '';
            })
            .addCase(deletePaymentReceiptOutflow.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error(action.error.message || 'Failed to delete payment');
            })

            // Delete vendor payment
            .addCase(deleteVendorPayment.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(deleteVendorPayment.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                const { message } = action.payload;
                toast.success(message || 'Vendor payment deleted successfully');
                state.errorMessage = '';
            })
            .addCase(deleteVendorPayment.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error(action.error.message || 'Failed to delete vendor payment');
            })

            // Create vendor payment PDF
            .addCase(createVendorPaymentPdf.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(createVendorPaymentPdf.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                toast.success('PDF created successfully');
                state.errorMessage = '';
            })
            .addCase(createVendorPaymentPdf.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error(action.error.message || 'Failed to create PDF');
            })
            

    }
});

export default cashInflowSlice.reducer;
